import { render, staticRenderFns } from "./ViewModal.vue?vue&type=template&id=b7310ad0&scoped=true"
import script from "./ViewModal.vue?vue&type=script&lang=js"
export * from "./ViewModal.vue?vue&type=script&lang=js"
import style0 from "./ViewModal.vue?vue&type=style&index=0&id=b7310ad0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7310ad0",
  null
  
)

export default component.exports